import script from "./DanhMucToaXeSearchInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./DanhMucToaXeSearchInput.vue?vue&type=script&lang=ts&setup=true"

import "./DanhMucToaXeSearchInput.vue?vue&type=style&index=0&id=2b0106b9&lang=css"

const __exports__ = script;

export default __exports__